import {createSelector} from "@reduxjs/toolkit";

const baseState = state => state.static_data;

export const staticDataSkills = createSelector([baseState], (state) => {
    return state.skills;
});

export const staticDataInterests = createSelector([baseState], (state) => {
    return state.interests;
});

export const staticDataOsaOffices = createSelector([baseState], (state) => {
    return state.osa_offices;
});